// src/components/Sidebar.js
import React, {useState} from 'react';
import { Link, useLocation, } from 'react-router-dom';
import { FaHome, FaUser, FaBriefcase, FaEnvelope, FaLinkedinIn, FaInstagram, FaWhatsapp } from 'react-icons/fa'; // Import icons from react-icons library
import './Sidebar.css';

const Sidebar = () => {

  const location = useLocation();
  // WhatsApp number
  const phoneNumber = '+916381178867'; // Replace with your WhatsApp number
  
  // WhatsApp link
  const whatsappLink = `https://wa.me/${phoneNumber}`;
  //mobile icon
  const [isMobile, setIsMobile]=useState(false);

  //mobile menu atomatically close once the page is open
  const closeMobileMenu = () => {
    if (isMobile) {
      setIsMobile(false);
    }
  };
  
  return (
    <div className="sidebar">

<img className='profileimg' alt="" src={require('./ragaviprofile.jpg')} />

      <nav>
        <ul className={ isMobile ? 'mobile-nav-items' : 'nav-items'}>
        <li className={location.pathname === '/' ? 'active' : ''} onClick={closeMobileMenu}>
            <Link to="/">
              <FaHome />
              <span className="sidebar-text">Home</span>
            </Link>
          </li>
          <li className={location.pathname === '/about' ? 'active' : ''} onClick={closeMobileMenu} >
            <Link to="/about">
              <FaUser />
              <span className="sidebar-text">About</span>
            </Link>
          </li>
          <li className={location.pathname === '/skills' ? 'active' : ''} onClick={closeMobileMenu}>
            <Link to="/skills">
              <FaBriefcase />
              <span className="sidebar-text">Skills</span>
            </Link>
          </li>
          <li className={location.pathname === '/contact' ? 'active' : ''} onClick={closeMobileMenu} >
            <Link to="/contact">
              <FaEnvelope />
              <span className="sidebar-text">Contact</span>
            </Link>
          </li>
        </ul>
        <button className='mobile-menu-icon' onClick={()=>setIsMobile(!isMobile)}>
      {isMobile ? <h1>X</h1> : <h1>=</h1>}
    </button>
      </nav>
     <hr></hr>
     <div className="sidebar-icon">
     <a href='https://www.linkedin.com/in/ragavi-j-8517601b2/'><FaLinkedinIn/></a>
     <a href='https://www.instagram.com/ragavi_jegathesan/'> <FaInstagram/></a>
     <a href={whatsappLink} target="_blank" rel="noopener noreferrer"><FaWhatsapp/></a>
     </div>


    </div>
  );
};

export default Sidebar;
